import type { AxiosResponse } from "axios";

import { getRequest } from "../HttpRequest";

export type ProductApiItem = {
  codigo_plano: number;
  valor_preco_base: number;
  aliquota_iof: number;
};

export type GetProductsResponse = {
  retorno: ProductApiItem[];
};

const CALCULATION_URL_TEMPLATE = import.meta.env.VITE_CALCULATION ?? "";

function buildProductsUrl(cod: string) {
  if (!CALCULATION_URL_TEMPLATE) {
    throw new Error("Variável de ambiente VITE_CALCULATION não configurada.");
  }

  return CALCULATION_URL_TEMPLATE.replace(
    "{codigo-produto}",
    encodeURIComponent(cod)
  );
}

export function getProducts(
  cod: string
): Promise<AxiosResponse<GetProductsResponse> | null> {
  const url = buildProductsUrl(cod);

  return getRequest<GetProductsResponse>(url);
}